<du-lipo-detail [detailModel]="detailModel"
                (onSaveClicked)="onSaveClick(detailModel!)"
                [navigateBack]="{commands: [LipoRouteEnum.CUSTOMER, customerId]}"
                [menuButtons]="menuButtons"></du-lipo-detail>
